import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_99: FaireProductEntity = {
  token: "starter_collection_99",
  type: "product",
  name: "Totem Glasses - Portofino",
  brandName: "Sophie Lou Jacobsen",
  imageUrl:
    '"https://cdn.faire.com/fastly/18ff33fd64aeca7dc478d31ab8a8d96b022b355338805fdf3bc0546504c3c6b5.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=3214',
  priceDollars: 88,
  msrpDollars: 176,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
